var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#4A60AB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1864_32655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7591 12.1224H13.1759V16.3255C13.1759 16.7519 13.5217 17.0972 13.9477 17.0972H16.0542C16.4802 17.0972 16.826 16.7519 16.826 16.3255V12.1224H18.2423C18.4769 12.1224 18.6879 11.9812 18.7781 11.7643C18.8674 11.5484 18.8177 11.2987 18.6519 11.133L15.4105 7.89113C15.1841 7.6652 14.8173 7.6652 14.5904 7.89113L11.3496 11.133C11.1837 11.2987 11.1341 11.548 11.2238 11.7643C11.314 11.9807 11.5245 12.1224 11.7591 12.1224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 13.6978C20.9198 13.6978 20.6082 14.0094 20.6082 14.3939V17.3045C20.6082 18.1764 19.8984 18.8857 19.0265 18.8857H10.9735C10.1015 18.8857 9.39219 18.1764 9.39219 17.3045V14.3939C9.39219 14.0094 9.08014 13.6978 8.6961 13.6978C8.3116 13.6978 8 14.0094 8 14.3939V17.3045C8 18.944 9.33387 20.278 10.9735 20.278H19.0265C20.6661 20.278 22 18.9441 22 17.3045V14.3939C22 14.0094 21.6884 13.6978 21.3039 13.6978Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1864_32655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueUpload);
export default __webpack_public_path__ + "static/media/blueUpload.59e213e449f135f44e063f4e4fc879b1.svg";
export { ForwardRef as ReactComponent };